export const GET_PACK = "pack/GET_PACK";
export const RENAME_PLAN = "pack/RENAME_PLAN";
export const NEW_PLAN = "pack/NEW_PLAN";
export const DELETE_PLAN = "pack/DELETE_PLAN";
export const DUPLICATE_PRIVATE_PLAN = "pack/DUPLICATE_PRIVATE_PLAN";
export const CHANGE_PACK_PLAN_COPY = "pack/CHANGE_PACK_PLAN_COPY";
export const CHANGE_PACK_SORTING = "pack/CHANGE_PACK_SORTING";
